import { createSessionHelpers } from '@s2w/core';

const STORAGE_KEY = 's2w.admin.session.token';
const MUST_RESET_PW_KEY = 's2w.admin.session.must-reset-pw';
const DISPLAY_NAME_KEY = 's2w.admin.session.display-name';

const { isAuthenticated, setSessionToken, clearSession } = createSessionHelpers({
  storageKey: STORAGE_KEY,
});

const storage = (): Storage | null => {
  if (typeof globalThis === 'undefined' || !('localStorage' in globalThis)) {
    return null;
  }
  return globalThis.localStorage;
};

export const getSessionToken = (): string | null => {
  return storage()?.getItem(STORAGE_KEY) ?? null;
};

export const setMustResetPassword = (mustResetPw: boolean): void => {
  storage()?.setItem(MUST_RESET_PW_KEY, mustResetPw ? '1' : '0');
};

export const mustResetPassword = (): boolean => {
  return storage()?.getItem(MUST_RESET_PW_KEY) === '1';
};

export const clearAdminSession = (): void => {
  clearSession();
  storage()?.removeItem(MUST_RESET_PW_KEY);
  storage()?.removeItem(DISPLAY_NAME_KEY);
};

export const setAdminDisplayName = (displayName: string): void => {
  storage()?.setItem(DISPLAY_NAME_KEY, displayName.trim());
};

export const getAdminDisplayName = (): string | null => {
  const value = storage()?.getItem(DISPLAY_NAME_KEY);
  return value && value.trim().length > 0 ? value : null;
};

export { isAuthenticated, setSessionToken, clearAdminSession as clearSession };
export type { SessionStore } from '@s2w/core';
